import ApplicationAdapter from './application';

export default class Group extends ApplicationAdapter {
  namespace = 'groups/v4/templates';
  modelNamePlural = 'groups';
}
